import React, { Fragment, useState } from "react"
import styled from "styled-components"
import colors from "../../../styles/colors"
import { withTranslation } from "gatsby-plugin-react-i18next"
import fonts from "../../../styles/fonts"
import OnClickButtonGreen from "../../Core/Buttons/OnClickButtonGreen"
import CloseArrow from "../../../resources/img/ui/plp/filter-arrow.svg"
import DropdownOpen from "../../../resources/img/ui/plp/dropdown-open.svg"
import DropdownClose from "../../../resources/img/ui/plp/dropdown-close.svg"

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${colors.white};
  z-index: 999;
  padding: 40px 22px;
  overflow-y: scroll;
`

const TitleSection = styled.div`
  margin-bottom: 26px;
  position: relative;
`

const CloseOverlay = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -6px;
  background: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const Title = styled.div`
  ${fonts.moretBold};
  font-size: 25px;
  text-align: center;
`

const Filters = styled.div`
  border-top: 1px solid ${colors.mediumDarkGrey};
  border-bottom: 1px solid ${colors.mediumDarkGrey};
`

const FilterDropdown = styled.div`
  padding: 17px;
  border-bottom: 1px solid ${colors.mediumDarkGrey};
  &:last-of-type {
    border-bottom: none;
  }
`

const FilterDropdownTitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    margin-right: -14px;
  }
`

const FilterDropdownTitle = styled.div`
  ${fonts.openSans};
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
`

const SelectedOption = styled.span`
  color: ${colors.mediumDarkGrey};
  font-weight: 400;
  text-transform: none;
`

const ButtonContainer = styled.div`
  margin-top: 40px;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  div,
  button {
    min-width: 100%;
    padding: 20px 40px;
  }
`

const ClearButton = styled.button`
  ${fonts.openSans};
  font-size: 14px;
  text-decoration: underline;
  text-transform: uppercase;
  margin-top: 24px;
  cursor: pointer;
  background: transparent;
  border: none;
  text-align: center;
  padding: 0 !important;
  min-width: unset !important;
`

const Drawer = styled.div`
  height: ${(props) => (props.visible ? "auto" : 0)};
  overflow: hidden;
`

const FilterDropdownOptions = styled.div`
  margin-top: 17px;
  display: ${(props) => (props.flex ? "flex" : "block")};
`

const SortOptionValue = styled.div`
  ${fonts.openSans};
  font-size: 14px;
  margin-bottom: 8px;
  color: ${(props) => (props.selected ? colors.lightGreen : colors.black)};
  text-decoration: ${(props) => (props.selected ? "underline" : "none")};
  font-weight: ${(props) => (props.selected ? "600" : "400")};
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;

  &:last-of-type {
    margin-bottom: 0;
  }
`

const ColourOptionValue = styled.div`
  display: flex;
  font-size: 14px;
  margin: 0 10px;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  border: ${(props) =>
    props.selected ? `1px solid ${colors.black}` : "1px solid transparent"};
  border-radius: 50%;
  cursor: pointer;

  img {
    width: 17px;
    height: 17px;
  }

  &:first-of-type {
    margin-left: 0;
  }
`

const OptionValue = styled.div`
  ${fonts.openSans};
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;

  &:last-of-type {
    margin-bottom: 0;
  }
`

const Checkbox = styled.div`
  width: 13px;
  height: 13px;
  border: 1px solid ${colors.black};
  background: ${(props) => (props.selected ? colors.lightGreen : colors.beige)};
  margin-right: 10px;
`

const FilterOverlay = (props) => {
  const {
    t,
    handleOverlay,
    open,
    filterOptions,
    sort,
    colours,
    types,
    styles,
    price,
    applyFilter,
    setSort,
    handleColour,
    handlePrice,
    handleTypeFilter,
    handleStyle,
    clearFilter,
  } = props

  const [openedFilter, setOpenedFilter] = useState(null)

  const handleDropdown = (index) => {
    if (index === openedFilter) {
      setOpenedFilter(null)
    } else {
      setOpenedFilter(index)
    }
  }

  const apply = () => {
    applyFilter()
    handleOverlay(false)
  }

  const renderOption = (option, filterValue) => {
    if (!option) return null
    switch (filterValue) {
      case "sort":
        return (
          <SortOptionValue
            selected={sort && sort.value === option.value}
            onClick={() => setSort(option)}
          >
            {option.title}
          </SortOptionValue>
        )

      case "colour":
        const selectedColours = [...colours]
        const selectedColourValues =
          selectedColours.length > 0
            ? selectedColours.map((colour) => colour?.value)
            : []
        return (
          <ColourOptionValue
            selected={selectedColourValues.includes(option.value)}
            onClick={() => handleColour(option)}
          >
            <img src={option.icon} alt={option.title} />
          </ColourOptionValue>
        )

      case "price":
        return (
          <OptionValue onClick={() => handlePrice(option)}>
            <Checkbox selected={price && price.value === option.value} />{" "}
            {option.title}
          </OptionValue>
        )

      case "type":
        const selectedTypes = [...types]
        const selectedTypeValues =
          selectedTypes.length > 0
            ? selectedTypes.map((type) => type?.value)
            : []
        return (
          <OptionValue onClick={() => handleTypeFilter(option)}>
            <Checkbox selected={selectedTypeValues.includes(option.value)} />{" "}
            {option.title}
          </OptionValue>
        )

      case "style":
        const selectedStyles = [...styles]
        const selectedStyleValues =
          selectedStyles.length > 0
            ? selectedStyles.map((style) => style?.value)
            : []
        return (
          <OptionValue onClick={() => handleStyle(option)}>
            <Checkbox selected={selectedStyleValues.includes(option.value)} />{" "}
            {option.title}
          </OptionValue>
        )

      default:
        break
    }
  }

  const formatSelectedValue = (string, filterType) => {
    let formattedString = string
    if (
      filterType === "colour" ||
      filterType === "type" ||
      filterType === "style"
    ) {
      formattedString =
        formattedString.length > 20
          ? formattedString.slice(0, 17) +
            "..." +
            `(${
              filterType === "type"
                ? types.length
                : filterType === "style"
                ? styles.length
                : colours.length
            })`
          : formattedString
    }

    return formattedString
  }

  return open ? (
    <Overlay>
      <TitleSection>
        <CloseOverlay onClick={() => handleOverlay(false)}>
          <img src={CloseArrow} alt="close filter" />
        </CloseOverlay>
        <Title>{t("plp.filter.sort_title")}</Title>
      </TitleSection>
      <Filters>
        {filterOptions.map((filter, index) => {
          if (!filter) return null

          const isOpen = openedFilter === index
          let selectedValue =
            filter.value === "sort"
              ? sort?.title
              : filter.value === "colour"
              ? colours.length > 0
                ? colours
                    .map(
                      (selectedValue, i) =>
                        selectedValue.title +
                        `${i === colours.length - 1 ? "" : ", "}`
                    )
                    .join("")
                : null
              : filter.value === "price"
              ? price?.title
              : filter.value === "type" && types.length > 0
              ? types
                  .map(
                    (selectedValue, i) =>
                      selectedValue.title +
                      `${i === types.length - 1 ? "" : ", "}`
                  )
                  .join("")
              : filter.value === "style" && styles.length > 0
              ? styles
                  .map(
                    (selectedValue, i) =>
                      selectedValue.title +
                      `${i === styles.length - 1 ? "" : ", "}`
                  )
                  .join("")
              : null

          return (
            <FilterDropdown>
              <FilterDropdownTitleSection onClick={() => handleDropdown(index)}>
                <FilterDropdownTitle>
                  {filter.title}
                  {selectedValue && (
                    <>
                      :{" "}
                      <SelectedOption>
                        {formatSelectedValue(selectedValue, filter.value)}
                      </SelectedOption>
                    </>
                  )}
                </FilterDropdownTitle>
                <img
                  src={isOpen ? DropdownClose : DropdownOpen}
                  alt={isOpen ? "Close" : "Open"}
                />
              </FilterDropdownTitleSection>
              <Drawer visible={isOpen}>
                <FilterDropdownOptions flex={filter.value === "colour"}>
                  {filter?.options?.map((option, index) => {
                    return (
                      <Fragment key={index}>
                        {renderOption(option, filter.value)}
                      </Fragment>
                    )
                  })}
                </FilterDropdownOptions>
              </Drawer>
            </FilterDropdown>
          )
        })}
      </Filters>
      <ButtonContainer>
        <OnClickButtonGreen onClick={() => apply()}>
          {t("plp.filter.sort_apply")}
        </OnClickButtonGreen>
        <ClearButton onClick={() => clearFilter()}>
          {t("plp.filter.sort_clear_all")}
        </ClearButton>
      </ButtonContainer>
    </Overlay>
  ) : null
}

export default withTranslation()(FilterOverlay)
